
import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const AnalyticsKPICard = ({ title, value, icon, color, subtitle }) => {
  return (
    <Card sx={{ height: "100%", boxShadow: "0 2px 10px rgba(0,0,0,0.05)", borderRadius: 2, border: `1px solid ${color}60`, bgcolor:`${color}20`}}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="overline" color="textSecondary" sx={{ fontWeight: 600, letterSpacing: 0.5, textTransform: 'capitalize' }}>
              {title.toLowerCase()}
            </Typography>
            <Typography variant="h4" sx={{ mt: 1, fontWeight: 700, color: "#1a237e" }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              p: 1,
              borderRadius: 4,
              bgcolor: `${color}15`,
              color: color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default React.memo(AnalyticsKPICard);
